//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './RoleClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';



export type GetRoleRoleQueryParameters = {
  id: number ;
}

export type EditRoleRoleQueryParameters = {
  id: number ;
}

export type RemoveRoleRoleQueryParameters = {
  id: number ;
}

export function getRolesUrl(): string {
  let url_ = getBaseUrl() + "/api/roles";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getRolesDefaultOptions: Omit<UseQueryOptions<Types.RoleDto[], unknown, Types.RoleDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.RoleDto[], unknown, Types.RoleDto[]>, 'queryFn'>> = {
};
export function getGetRolesDefaultOptions() {
  return getRolesDefaultOptions;
};
export function setGetRolesDefaultOptions(options: typeof getRolesDefaultOptions) {
  getRolesDefaultOptions = options;
}

export function getRolesQueryKey(): QueryKey;
export function getRolesQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'RoleClient',
      'getRoles',
    ]);
}
export function __getRoles(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getRoles(
axiosConfig    );
}

/**
 * Gets all roles.
 */
export function useGetRolesQuery<TSelectData = Types.RoleDto[], TError = unknown>(options?: Omit<UseQueryOptions<Types.RoleDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetRolesQuery<TSelectData = Types.RoleDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.RoleDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.RoleDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getRoles(context, axiosConfig) : __getRoles,
    queryKey: getRolesQueryKey(),
    ...getRolesDefaultOptions as unknown as Omit<UseQueryOptions<Types.RoleDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets all roles.
 */
export function setGetRolesData(queryClient: QueryClient, updater: (data: Types.RoleDto[] | undefined) => Types.RoleDto[], ) {
  queryClient.setQueryData(getRolesQueryKey(),
    updater
  );
}

/**
 * Gets all roles.
 */
export function setGetRolesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.RoleDto[] | undefined) => Types.RoleDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createRoleUrl(): string {
  let url_ = getBaseUrl() + "/api/roles";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createRoleMutationKey(): MutationKey {
  return trimArrayEnd([
      'RoleClient',
      'createRole',
    ]);
}

/**
 * Creates a role.
 * @param newRole Request parameter
 */
export function useCreateRoleMutation<TContext>(options?: Omit<UseMutationOptions<Types.RoleDto, unknown, Types.CreateRoleDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.RoleDto, unknown, Types.CreateRoleDto, TContext> {
  const key = createRoleMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (newRole: Types.CreateRoleDto) => Client.createRole(newRole),
    mutationKey: key,
  });
}
  
export function getPermissionsUrl(): string {
  let url_ = getBaseUrl() + "/api/roles/permissions";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getPermissionsDefaultOptions: Omit<UseQueryOptions<string[], unknown, string[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<string[], unknown, string[]>, 'queryFn'>> = {
};
export function getGetPermissionsDefaultOptions() {
  return getPermissionsDefaultOptions;
};
export function setGetPermissionsDefaultOptions(options: typeof getPermissionsDefaultOptions) {
  getPermissionsDefaultOptions = options;
}

export function getPermissionsQueryKey(): QueryKey;
export function getPermissionsQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'RoleClient',
      'getPermissions',
    ]);
}
export function __getPermissions(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getPermissions(
axiosConfig    );
}

/**
 * Gets permissions.
 */
export function useGetPermissionsQuery<TSelectData = string[], TError = unknown>(options?: Omit<UseQueryOptions<string[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetPermissionsQuery<TSelectData = string[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<string[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<string[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getPermissions(context, axiosConfig) : __getPermissions,
    queryKey: getPermissionsQueryKey(),
    ...getPermissionsDefaultOptions as unknown as Omit<UseQueryOptions<string[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets permissions.
 */
export function setGetPermissionsData(queryClient: QueryClient, updater: (data: string[] | undefined) => string[], ) {
  queryClient.setQueryData(getPermissionsQueryKey(),
    updater
  );
}

/**
 * Gets permissions.
 */
export function setGetPermissionsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: string[] | undefined) => string[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function getRoleUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/roles/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getRoleDefaultOptions: Omit<UseQueryOptions<Types.RoleDto, unknown, Types.RoleDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.RoleDto, unknown, Types.RoleDto>, 'queryFn'>> = {
};
export function getGetRoleDefaultOptions() {
  return getRoleDefaultOptions;
};
export function setGetRoleDefaultOptions(options: typeof getRoleDefaultOptions) {
  getRoleDefaultOptions = options;
}

export function getRoleQueryKey(id: number): QueryKey;
export function getRoleQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetRoleRoleQueryParameters;

    return trimArrayEnd([
        'RoleClient',
        'getRole',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'RoleClient',
        'getRole',
        ...params
      ]);
  }
}
export function __getRole(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getRole(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetRoleQuery<TSelectData = Types.RoleDto, TError = unknown>(dto: GetRoleRoleQueryParameters, options?: Omit<UseQueryOptions<Types.RoleDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets a role by id.
 * @param id The role id.
 */
export function useGetRoleQuery<TSelectData = Types.RoleDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.RoleDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetRoleQuery<TSelectData = Types.RoleDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.RoleDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetRoleRoleQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.RoleDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getRole(context, axiosConfig) : __getRole,
    queryKey: getRoleQueryKey(id),
    ...getRoleDefaultOptions as unknown as Omit<UseQueryOptions<Types.RoleDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets a role by id.
 * @param id The role id.
 */
export function setGetRoleData(queryClient: QueryClient, updater: (data: Types.RoleDto | undefined) => Types.RoleDto, id: number) {
  queryClient.setQueryData(getRoleQueryKey(id),
    updater
  );
}

/**
 * Gets a role by id.
 * @param id The role id.
 */
export function setGetRoleDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.RoleDto | undefined) => Types.RoleDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function editRoleUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/roles/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function editRoleMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'RoleClient',
      'editRole',
      id as any,
    ]);
}

/**
 * Edits a role.
 * @param id The role id.
 * @param updatedRole Request parameter
 */
export function useEditRoleMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, Types.UpdateRoleDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.UpdateRoleDto, TContext> {
  const key = editRoleMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (updatedRole: Types.UpdateRoleDto) => Client.editRole(id, updatedRole),
    mutationKey: key,
  });
}
  
type EditRole__MutationParameters = EditRoleRoleQueryParameters & {
  updatedRole: Types.UpdateRoleDto;
}

/**
 * Edits a role.
 * @param id The role id.
 * @param updatedRole Request parameter
 */
export function useEditRoleMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, EditRole__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: EditRoleRoleQueryParameters}): UseMutationResult<void, unknown, EditRole__MutationParameters, TContext> {
  const key = editRoleMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: EditRole__MutationParameters) => Client.editRole(data.id ?? options?.parameters?.id!, data.updatedRole),
  mutationKey: key,
});
}
  
export function removeRoleUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/roles/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeRoleMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'RoleClient',
      'removeRole',
      id as any,
    ]);
}

/**
 * Removes a role.
 * @param id The role id.
 */
export function useRemoveRoleMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeRoleMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.removeRole(id),
    mutationKey: key,
  });
}
  
type RemoveRole__MutationParameters = RemoveRoleRoleQueryParameters

/**
 * Removes a role.
 * @param id The role id.
 */
export function useRemoveRoleMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, RemoveRole__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveRoleRoleQueryParameters}): UseMutationResult<void, unknown, RemoveRole__MutationParameters, TContext> {
  const key = removeRoleMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: RemoveRole__MutationParameters) => Client.removeRole(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}